import { combineReducers } from '@reduxjs/toolkit';

import adminMenuReducer from '../app/layout/navbar/adminMenuSlice';
import deleteDialogReducer from '../common/components/deleteDialog/deleteDialogSlice';
import editDrawerReducer from '../common/components/EditDrawer/editDrawerSlice';
import exportDialogReducer from '../common/components/exportDialog/exportDialogSlice';
import palmDataGridReducer from '../common/components/PalmDataGrid/palmDataGridSlice';
import userProfilesReducer from '../common/components/sharedCustomComponents/userProfiles/userProfilesSlice';
import aclAccessesReducer from '../features/aclAccesses/aclAccessesSlice';
import aclConditionsReducer from '../features/aclConditions/aclConditionsSlice';
import aclResourcesReducer from '../features/aclResources/aclResourcesSlice';
import accountLinkingDashboardReducer from '../features/admin/subpages/accountLinkingDashboard/accountLinkingDashboardSlice';
import apiKeysReducer from '../features/apiKeys/apiKeysSlice';
import applicationSuitesReducer from '../features/applicationSuites/applicationSuitesSlice';
import authorizedIssuersReducer from '../features/authorizedIssuers/authorizedIssuersSlice';
import billingSystemsReducer from '../features/billingSystems/billingSystemsSlice';
import claimDataTypesReducer from '../features/claimDataTypes/claimDataTypesSlice';
import claimRoleMembershipReducer from '../features/claimRoleMembership/claimRoleMembershipSlice';
import claimReducer from '../features/claims/claimsSlice';
import claimUserMembershipReducer from '../features/claimUserMembership/claimUserMembershipSlice';
import globalRolesReducer from '../features/globalRoles/globalRolesSlice';
import identityProvidersReducer from '../features/identityProviders/identityProvidersSlice';
import licenseAclEntriesReducer from '../features/licenseAclEntries/licenseAclEntriesSlice';
import licensesReducer from '../features/licenses/licensesSlice';
import licenseUserGroupsReducer from '../features/licenseUserGroups/licenseUserGroupsSlice';
import licenseUsersReducer from '../features/licenseUsers/licenseUsersSlice';
import productPackageRalsReducer from '../features/productPackageRals/productPackageRalsSlice';
import productPackagesReducer from '../features/productPackages/productPackageSlice';
import reportPrintingModalReducer from '../features/reports/reportPrintingModalSlice';
import tenantSearchableDropDownReducer from '../features/reports/tenantSearchableDropDownSlice';
import roleClaimMembershipReducer from '../features/roleClaimMembership/roleClaimMembershipSlice';
import rolesReducer from '../features/roles/rolesSlice';
import roleUserGroupReducer from '../features/roleUserGroup/roleUserGroupSlice';
import roleUserMembershipReducer from '../features/roleUserMembership/roleUserMembershipSlice';
import tenantsReducer from '../features/tenants/tenantsSlice';
import tenantUserMembershipReducer from '../features/tenantUserMembership/tenantUserMembershipSlice';
import userAclEntriesReducer from '../features/userAclEntries/userAclEntriesSlice';
import userClaimMembershipReducer from '../features/userClaimMembership/userClaimMembershipSlice';
import aclEntriesReducer from '../features/userGroupAclEntries/aclEntriesSlice';
import userGroupRoleMembershipReducer from '../features/userGroupRoleMembership/userGroupRoleMembershipSlice';
import userGroupReducer from '../features/userGroups/userGroupsSlice';
import userGroupsUsersReducer from '../features/userGroupsUsers/userGroupsUsersSlice';
import userGroupUserMembershipReducer from '../features/userGroupUserMembership/userGroupUserMembershipSlice';
import userProfileAclsReducer from '../features/userProfileAcls/userProfileAclsSlice';
import userProfileAppsTenantsReducer from '../features/userProfileApps/UserProfileAppsTenantsSlice';
import userProfileClaimsReducer from '../features/userProfileClaims/userProfileClaimsSlice';
import userProfileForeignSystemReducer from '../features/userProfileForeignSystems/userProfileForeignSystemsSlice';
import userProfileGlobalRolesReducer from '../features/userProfileGlobalRoles/userProfileGlobalRolesSlice';
import userProfileIdentitiesReducer from '../features/userProfileIdentities/userProfileIdentitiesSlice';
import userProfileRolesReducer from '../features/userProfileRoles/userProfileRolesSlice';
import userProfileUserGroupsReducer from '../features/userProfileUserGroups/userProfileUserGroupsSlice';
import userRoleMembershipReducer from '../features/userRoleMemberships/userRoleMembershipsSlice';
import usersReducer from '../features/users/usersSlice';

export const rootReducer = combineReducers({
    adminMenu: adminMenuReducer,
    applicationSuites: applicationSuitesReducer,
    tenants: tenantsReducer,
    apiKeys: apiKeysReducer,
    editDrawer: editDrawerReducer,
    palmDataGrid: palmDataGridReducer,
    licenses: licensesReducer,
    deleteDialog: deleteDialogReducer,
    exportDialog: exportDialogReducer,
    aclResources: aclResourcesReducer,
    aclAccesses: aclAccessesReducer,
    aclConditions: aclConditionsReducer,
    authorizedIssuers: authorizedIssuersReducer,
    identityProviders: identityProvidersReducer,
    globalRoles: globalRolesReducer,
    roles: rolesReducer,
    userGroups: userGroupReducer,
    claimDataTypes: claimDataTypesReducer,
    claims: claimReducer,
    aclEntries: aclEntriesReducer,
    roleClaimMembership: roleClaimMembershipReducer,
    userGroupRoleMembership: userGroupRoleMembershipReducer,
    roleUserGroup: roleUserGroupReducer,
    claimRoleMembership: claimRoleMembershipReducer,
    billingSystems: billingSystemsReducer,
    tenantUserMembership: tenantUserMembershipReducer,
    userAclEntries: userAclEntriesReducer,
    roleUserMembership: roleUserMembershipReducer,
    userGroupsUsers: userGroupsUsersReducer,
    users: usersReducer,
    userProfiles: userProfilesReducer,
    userGroupUserMembership: userGroupUserMembershipReducer,
    userRoleMembership: userRoleMembershipReducer,
    claimUserMembership: claimUserMembershipReducer,
    userClaimMembership: userClaimMembershipReducer,
    userProfileForeignSystem: userProfileForeignSystemReducer,
    userProfileAppsTenants: userProfileAppsTenantsReducer,
    userProfileGlobalRoles: userProfileGlobalRolesReducer,
    userProfileUserGroups: userProfileUserGroupsReducer,
    userProfileIdentities: userProfileIdentitiesReducer,
    userProfileRoles: userProfileRolesReducer,
    userProfileClaims: userProfileClaimsReducer,
    userProfileAcls: userProfileAclsReducer,
    reportPrintingModal: reportPrintingModalReducer,
    licenseAclEntries: licenseAclEntriesReducer,
    licenseUsers: licenseUsersReducer,
    licenseUserGroups: licenseUserGroupsReducer,
    tenantSearchableDropDown: tenantSearchableDropDownReducer,
    accountLinkingDashboard: accountLinkingDashboardReducer,
    productPackages: productPackagesReducer,
    productPackageRals: productPackageRalsReducer
});

// Infer the RootState type from the root reducer
export type RootState = ReturnType<typeof rootReducer>;
